export function useLayoutSty(){

  /**
   * 设置默认的宽高信息
   */
  const layoutSty=computed(()=>{
    return {};
  })

  return {
    layoutSty
  }
}
